
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infinite-scroll",
      function () {
        return require("private-next-pages/infinite-scroll/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infinite-scroll"])
      });
    }
  